window.lp.utils.showStatusIndicator = function (statusMessage) {

	$('body').css('cursor', 'progress');
	$('#statusMessage')
		.hide()
		.html(statusMessage || 'Loading...')
		.fadeIn('slow');

};

window.lp.utils.hideStatusIndicator = function () {

	$('body').css('cursor', '');
	$('#statusMessage').fadeOut('slow').html('');

};

$(() => {

	// Collapsible
	$('.collapsibleToggle').on('click', function () {

		const $el = $(this).closest('.collapsible');
		if ($el.hasClass('collapsed')) {

			$el.removeClass('collapsed');
			$('.collapsibleShowHideLabel', $el).text('Hide');
			$('.collapsibleMoreLessLabel', $el).text('Less');
			$('.caret', $el).removeClass('down');

			if ($('.caret', $el).hasClass('forceUp')) {

				$('.caret', $el).addClass('up');

			}

		} else {

			$el.addClass('collapsed');
			$('.collapsibleShowHideLabel', $el).text('Show');
			$('.collapsibleMoreLessLabel', $el).text('More');
			$('.caret', $el).addClass('down');

			if ($('.caret', $el).hasClass('forceUp')) {

				$('.caret', $el).removeClass('up');

			}

		}

	});

});
